// removed by extract-text-webpack-plugin
module.exports = {"minibagFooter":"_3L-aps4"};


//////////////////
// WEBPACK FOOTER
// ./template/components/MiniBag/Footer/index.css
// module id = ./template/components/MiniBag/Footer/index.css
// module chunks = client.sitechrome